import React from 'react'
import { useNavigate } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import OwnershipForm from '../../components/Ownership/OwnershipForm'

function OwnershipCreate() {
    const navigate = useNavigate()
    // handleGoBack
    const handleGoBack = () => {
        navigate('/ownership-list')
    }

    // create action
    const handleForm = async (data) => {
        if (data) {
            try {
                const response = await nbrApi.post('/createownershipgroup', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Ownership Group Created Successfully',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Ownership Group Create failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Ownership Group Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create Ownership Record</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'>Back to List</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <OwnershipForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OwnershipCreate
